export default __webpack_public_path__ + "static/media/dtm.6b611eed.webp";